import App from "../website/App";
import TermsOfService from "../website/sections/terms-of-service/TermsOfService";

window.App = App;
window.Section = TermsOfService;